<template>
  <v-container fluid style="height: 100%" class="d-flex align-center">
    <v-row class="fill-height">
      <v-col
        class="d-flex"
        v-for="(type_statement, index) in types_statement"
        :key="index"
        cols="12"
        md="4"
      >
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              min-width="100%"
              flat
              outlined
              rounded="xl"
              @click="selectTypeStmHostel(index, type_statement.type_name)"
              :disabled="disabledTypeStatement(type_statement.type_name)"
            >
              <v-card-title>
                <h6 class="text-h5 mx-auto" v-text="type_statement.type_name"></h6>
              </v-card-title>
              <v-card-text>
                <v-fade-transition>
                  <v-overlay
                    class="rounded-xl"
                    v-if="hover"
                    absolute
                    color="#036358"
                  ></v-overlay>
                </v-fade-transition>
                <div class="text-center" v-if="Object.keys(last_actual_statement).length === 0">
                  {{ type_statement.warning_text }}
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";

    export default {
        name: "TypeStatement",
        data: () => ({
            types_statement: [
                {
                    type_name: 'Заселение',
                    disable: false
                },
                {
                    type_name: 'Переселение',
                    warning_text: 'На данный момент информация о вашем проживании отсутствует!',
                    disable: false
                },
                {
                    type_name: 'Выселение',
                    warning_text: 'На данный момент информация о вашем проживании отсутствует!',
                    disable: false
                }
            ]
        }),
        computed: {
            ...mapState({
                place_hostel: state => state.interactionStatement.place_hostel,
                last_actual_statement: state => state.interactionStatement.last_actual_statement,
            }),
        },

        methods: {
            ...mapMutations({
                setStatementHostelType: 'interactionStatement/setStatementHostelType'
            }),
            ...mapActions({
                NextTab: 'interactionStatement/NextTab',
            }),
            selectTypeStmHostel(index, type_name) {
                this.setStatementHostelType(type_name)
                this.NextTab()
            },
            disabledTypeStatement(type_name) {
                const last_statement = this.last_actual_statement

                if (Object.keys(last_statement).length === 0) {
                    return type_name !== 'Заселение'
                }

                const last_type = last_statement.type_statement

                if (last_type === 'Заселение' || last_type === 'Переселение') {
                    return false
                }

                if (last_type === 'Выселение') {
                    return type_name === 'Выселение'
                }

                return false
            }
        },
    }
</script>

<style scoped>

</style>